import pick from 'lodash/pick';
import { TRAVELMODE_DONE } from 'utils/directions/constants';
import { idList, idObject } from 'utils/arrays';
import Leg, { legDistances } from './Leg';
import parseWaypointsString from './parseWaypointString';

function editCurrent(route) {
  const { points } = route;
  const waypoints = parseWaypointsString(
    route.waypoints,
    points.length,
    route.distance,
  );
  const legs = waypoints
    .reduce(
      (acc, wi, idx) => [
        ...acc,
        points.slice(idx === 0 ? 0 : waypoints[idx - 1], wi + 1),
      ],
      [[points[0]]],
    )
    .map(leg => new Leg(leg, TRAVELMODE_DONE));
  return {
    ...idObject(legs),
    legs: idList(legs),
    distance: legDistances(legs),
    bounds: route.bounds,
    meta: pick(route, [
      'id',
      'user_id',
      'title',
      'description',
      'city',
      'province',
      'country',
      'lat',
      'lng',
      'isPublic',
    ]),
  };
}

export default editCurrent;
